import { render, staticRenderFns } from "./ViewComments.vue?vue&type=template&id=6ae1729d&scoped=true&"
import script from "./ViewComments.vue?vue&type=script&lang=js&"
export * from "./ViewComments.vue?vue&type=script&lang=js&"
import style0 from "./ViewComments.vue?vue&type=style&index=0&id=6ae1729d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae1729d",
  null
  
)

export default component.exports